// app/javascript/controllers/archived_highlight_controller.js
import { Controller } from "@hotwired/stimulus"

// This controller highlights the select dropdown if an archived category is chosen.
// It expects each <option> to have a data-archived attribute ("true" or "false").

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.highlightArchived()
  }

  highlightArchived() {
    const option = this.selectTarget.selectedOptions[0]
    const isArchived = option?.dataset.archived === "true"

    if (isArchived) {
      this.selectTarget.classList.add("border-danger", "bg-danger-subtle")
    } else {
      this.selectTarget.classList.remove("border-danger", "bg-danger-subtle")
    }
  }

  change() {
    this.highlightArchived()
  }
}
